import api from "./api";
import { type Admin } from "../../types/database";

interface RawAdmin {
  id?: string;
  drivenPublishingHouse?: string;
  role?: string | null;
  isGrid?: boolean;
}

/** admins/{uid} via gateway. The gateway scopes this to the caller. */
export async function getAdmin(uid: string): Promise<Admin> {
  const data = await api.get<unknown, RawAdmin>("/getAdmin", {
    params: { id: uid },
  });
  return {
    id: data.id ?? uid,
    isGrid: Boolean(data.isGrid),
    publishingHouseId: data.drivenPublishingHouse ?? "",
    role: data.role ?? null,
  };
}

export async function updateAdmin(
  uid: string,
  patch: Partial<{ isGrid: boolean }>,
): Promise<void> {
  await api.patch("/updateAdmin", patch, { params: { id: uid } });
}
